import { addressWrapper } from "../Functions";

export class AutoCompleteBox {
  constructor(map, infoWindow) {
    this.map = map;
    this.infoWindow = infoWindow;
  }

  createControl(fillInFormCallback, formPrefix) {
    const inputWrapper = document.createElement("div");
    inputWrapper.style.margin = "10px 0 0 10px";
    inputWrapper.classList = "pac-target-input-wrapper";
    const input = document.createElement("input");
    input.placeholder = "Search for a location";
    inputWrapper.appendChild(input);

    // eslint-disable-next-line no-undef
    google.maps.event.addDomListener(input, "keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });

    // eslint-disable-next-line no-undef
    this.autoComplete = new google.maps.places.Autocomplete(input);
    this.autoComplete.bindTo("bounds", this.map);

    this.autoComplete.addListener("place_changed", () => {
      this.infoWindow.close();
      const place = this.autoComplete.getPlace();

      if (!place.geometry || !place.geometry.location) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }

      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(17);
      }

      this.infoWindow.setContent(addressWrapper(place.formatted_address, fillInFormCallback, place, formPrefix));
      this.infoWindow.setPosition(place.geometry.location);
      this.infoWindow.open(this.map);
    });

    // eslint-disable-next-line no-undef
    this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(inputWrapper);
  }
}
